module.exports = __webpack_public_path__ + "img/05.8fd8983a.jpg";